export const VIEWPORT_TOKENS = {
  /**
   * Below this width the planner uses CompactShell chrome.
   * Desktop laptops at 1280+ keep the current overlay layout.
   * Do not reuse Tailwind `tablet`/`laptop` screens: those exist for Home/Login
   * (`laptop` starts at 1580px) and would mis-classify planner viewports.
   */
  compactMaxWidthPx: 1280,
  /**
   * Touch tablets in landscape (iPad Pro 12.9 is 1366) would otherwise get the
   * desktop catalog, which grows with each submenu. Coarse pointers stay compact
   * up to this width.
   */
  tabletCompactMaxWidthPx: 1600,
  /**
   * Shortest viewport side at or above this is a tablet (iPad), not a phone.
   * Phones in landscape can exceed 720px width but their short side stays ~390.
   */
  compactTabletMinShortSidePx: 720,
} as const

export type LayoutMode = 'desktop' | 'compact'
export type PointerMode = 'fine' | 'coarse'
export type Orientation = 'portrait' | 'landscape'

export type ViewportCapabilities = {
  layoutMode: LayoutMode
  pointerMode: PointerMode
  orientation: Orientation
  width: number
  height: number
  /** Compact iPad/tablet, never a phone (including landscape). */
  isCompactTablet: boolean
  safeArea: {
    top: number
    bottom: number
    left: number
    right: number
  }
}

export const DESKTOP_VIEWPORT_FALLBACK: ViewportCapabilities = {
  layoutMode: 'desktop',
  pointerMode: 'fine',
  orientation: 'landscape',
  width: 1920,
  height: 1080,
  isCompactTablet: false,
  safeArea: { top: 0, bottom: 0, left: 0, right: 0 },
}
